module.exports = __webpack_public_path__ + "img/定期诊断反馈@2x.ca0a241d.png";